"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelFieldAnchor = exports.ModelMutatorAnchor = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var geodesic_1 = require("../../../geo/geodesic");
var math_1 = require("../../../math");
var unit_1 = require("../../../unit");
var collection_field_1 = require("../collection.field");
var location_field_1 = require("./location.field");
var ModelMutatorAnchor = /** @class */ (function (_super) {
    tslib_1.__extends(ModelMutatorAnchor, _super);
    function ModelMutatorAnchor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // Mutator to edit a vector anchor manually
    ModelMutatorAnchor.prototype.manualAnchor = function (newValue) {
        if (newValue == null || newValue.distance == null || newValue.bearing == null) {
            this.state.setFieldValue(this.field.id, null);
            return;
        }
        // Force the anchor bearing to be between 0 and two Pi
        newValue.bearing = unit_1.IkeAngle.normalize(newValue.bearing);
        // Sometimes pitch is not set, It is a required field
        if (newValue.pitch == null || isNaN(newValue.pitch)) {
            newValue.pitch = 0;
        }
        newValue.collectionTool = CollectionModelFieldAnchor.COLLLECTION_TOOL_VECTOR;
        this.state.setFieldValue(this.field.id, {
            provider: CollectionModelFieldAnchor.PROVIDER_MANUAL,
            value: newValue
        });
    };
    // Mutator when adding a new p2p vector
    ModelMutatorAnchor.prototype.p2p = function (state, placement) {
        if (!Array.isArray(state)) {
            throw new Error("Field ".concat(this.field.id, ": Invalid capture state."));
        }
        if (state.length < 2) {
            throw new Error("Field ".concat(this.field.id, ": Invalid capture count \"").concat(state.length, "\"."));
        }
        this.state.setFieldValue(this.field.id, {
            provider: CollectionModelFieldAnchor.PROVIDER_P2P,
            captures: state.slice(),
            value: {
                collectionTool: CollectionModelFieldAnchor.COLLLECTION_TOOL_VECTOR,
                placement: placement
            }
        });
    };
    // Method used by viewVectorManualEdit
    ModelMutatorAnchor.prototype.manual = function (newValue) {
        if (newValue == null || newValue.distance == null || newValue.bearing == null) {
            this.state.setFieldValue(this.field.id, null);
            return;
        }
        var anchorManualData = {
            collectionTool: CollectionModelFieldAnchor.COLLLECTION_TOOL_VECTOR,
            placement: newValue.placement,
            distance: newValue.distance,
            bearing: newValue.bearing,
            pitch: newValue.pitch,
            relatedSpanIds: newValue.relatedSpanIds
        };
        this.manualAnchor(anchorManualData);
    };
    // Mutator when adding anchor with gps position
    ModelMutatorAnchor.prototype.gps = function (newValue) {
        // Validate GPS coordinates
        if (!location_field_1.CollectionModelFieldLocation.isValidLocation(newValue)) {
            this.clear();
            return;
        }
        var value = {
            latitude: newValue.latitude,
            longitude: newValue.longitude,
            altitude: newValue.altitude,
            collectionTool: newValue.collectionTool,
            placement: newValue.placement,
            relatedSpanIds: newValue.relatedSpanIds
        };
        if (newValue.accuracy != null) {
            value.accuracy = newValue.accuracy;
        }
        var stateValue = {
            provider: 'gps',
            value: value
        };
        this.state.setFieldValue(this.field.id, stateValue);
    };
    // Set anntenaHeight value
    ModelMutatorAnchor.prototype.setAntennaHeight = function (antennaHeight) {
        var stateValue = this.state.getFieldValue(this.field.id);
        stateValue.antennaHeight = antennaHeight;
    };
    ModelMutatorAnchor.prototype.copy = function (from) {
        if (from.isPointToPoint()) {
            this.p2p(from.stateValue.captures, from.value.placement);
            return true;
        }
        if (from.isManual()) {
            this.manualAnchor(from.value);
            return true;
        }
        return false;
    };
    return ModelMutatorAnchor;
}(collection_field_1.ModelMutator));
exports.ModelMutatorAnchor = ModelMutatorAnchor;
var CollectionModelFieldAnchor = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionModelFieldAnchor, _super);
    function CollectionModelFieldAnchor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CollectionModelFieldAnchor.isAnchorField = function (f) {
        return f.schema.type === CollectionModelFieldAnchor.TYPE;
    };
    CollectionModelFieldAnchor.isCollectionWithVectorTool = function (value) {
        return value.collectionTool === CollectionModelFieldAnchor.COLLLECTION_TOOL_VECTOR;
    };
    CollectionModelFieldAnchor.isCollectionWithLocationTool = function (value) {
        return value.collectionTool === CollectionModelFieldAnchor.COLLLECTION_TOOL_LOCATION;
    };
    Object.defineProperty(CollectionModelFieldAnchor.prototype, "Mutator", {
        get: function () {
            if (this._Mutator == null) {
                this._Mutator = new ModelMutatorAnchor(this);
            }
            return this._Mutator;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelFieldAnchor.prototype, "value", {
        get: function () {
            var stateValue = this.stateValue;
            if (stateValue == null) {
                return null;
            }
            if (stateValue.value.collectionTool === CollectionModelFieldAnchor.COLLLECTION_TOOL_LOCATION) {
                // If a placement is not provided, then we want to default to Other
                var locationState = stateValue.value;
                locationState.placement = locationState.placement || CollectionModelFieldAnchor.DEFAULT_PLACEMENT;
                return locationState;
            }
            if (stateValue.value.collectionTool === CollectionModelFieldAnchor.COLLLECTION_TOOL_VECTOR) {
                if (this.isManual()) {
                    return stateValue.value;
                }
                if (this.isPointToPoint()) {
                    var vectorValue = math_1.MultiPoint.Points(this.getCaptures());
                    // To be backwards compatible, vertical values should not have a sign on them
                    vectorValue.vertical = Math.abs(vectorValue.vertical);
                    vectorValue.collectionTool = CollectionModelFieldAnchor.COLLLECTION_TOOL_VECTOR;
                    vectorValue.placement = stateValue.value.placement;
                    return vectorValue;
                }
            }
            throw new Error("Field ".concat(this.id, ": Invalid Provider type \"").concat(stateValue['provider'], "\""));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelFieldAnchor.prototype, "raw", {
        /**
         * Get the raw location data calculating alternative altitudes
         *
         * @remarks This cannot be null
         */
        get: function () {
            if (!this.isGPS()) {
                return {};
            }
            var stateValue = this.stateValue;
            var isAntennaHeightMissing = stateValue.antennaHeight == null || stateValue.antennaHeight === 0;
            if (isAntennaHeightMissing) {
                return tslib_1.__assign(tslib_1.__assign({}, (0, location_field_1.extractLocationRaw)(stateValue)), { deviceAltitude: stateValue.value.altitude, antennaHeight: undefined // Destroy antennaHeight if it is 0
                 });
            }
            return tslib_1.__assign(tslib_1.__assign({}, (0, location_field_1.extractLocationRaw)(stateValue)), { deviceAltitude: stateValue.antennaHeight + stateValue.value.altitude, groundAltitude: stateValue.value.altitude, antennaHeight: stateValue.antennaHeight });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelFieldAnchor.prototype, "provider", {
        get: function () {
            var stateValue = this.stateValue;
            if (stateValue == null || stateValue.provider == null) {
                return CollectionModelFieldAnchor.PROVIDER_MANUAL;
            }
            return stateValue.provider;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelFieldAnchor.prototype, "antennaHeight", {
        get: function () {
            var stateValue = this.stateValue;
            if (stateValue == null || stateValue.antennaHeight == null) {
                return 0;
            }
            return stateValue.antennaHeight;
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelFieldAnchor.prototype.target = function (source) {
        if (CollectionModelFieldAnchor.isCollectionWithVectorTool(this.value)) {
            var bearing = this.value.bearing;
            var distance = this.value.distance;
            return geodesic_1.IkeGeodesic.projectLocation(source, bearing, distance);
        }
        if (CollectionModelFieldAnchor.isCollectionWithLocationTool(this.value)) {
            return {
                altitude: this.value.altitude,
                longitude: this.value.longitude,
                latitude: this.value.latitude
            };
        }
        return null;
    };
    CollectionModelFieldAnchor.prototype.distanceBearingPitch = function (source) {
        if (!this.value) {
            return {
                distance: 0,
                bearing: 0,
                pitch: 0
            };
        }
        if (CollectionModelFieldAnchor.isCollectionWithVectorTool(this.value)) {
            return {
                distance: this.value.distance,
                bearing: this.value.bearing,
                pitch: this.value.pitch
            };
        }
        if (CollectionModelFieldAnchor.isCollectionWithLocationTool(this.value)) {
            return geodesic_1.IkeGeodesic.getVector(source, this.stateValue.value);
        }
        return null;
    };
    CollectionModelFieldAnchor.prototype.isManual = function () {
        return this.provider === CollectionModelFieldAnchor.PROVIDER_MANUAL;
    };
    CollectionModelFieldAnchor.prototype.isPointToPoint = function () {
        return this.provider === CollectionModelFieldAnchor.PROVIDER_P2P;
    };
    CollectionModelFieldAnchor.prototype.isGPS = function () {
        return this.provider === CollectionModelFieldAnchor.PROVIDER_GPS;
    };
    CollectionModelFieldAnchor.prototype.isTrueSize = function () {
        return false;
    };
    Object.defineProperty(CollectionModelFieldAnchor.prototype, "tool", {
        // Get tool used for collection, by default we show a Vector tool
        get: function () {
            var stateValue = this.stateValue;
            if (stateValue == null || stateValue.value.collectionTool == null) {
                return CollectionModelFieldAnchor.COLLLECTION_TOOL_VECTOR;
            }
            return stateValue.value.collectionTool;
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelFieldAnchor.prototype.getOwnedCaptures = function () {
        return this.getCaptures();
    };
    CollectionModelFieldAnchor.prototype.getCaptures = function () {
        var captures = [];
        var captureIds = this.getCaptureIds();
        for (var _i = 0, captureIds_1 = captureIds; _i < captureIds_1.length; _i++) {
            var captureId = captureIds_1[_i];
            var capture = this.collection.state.getCapture(captureId);
            if (capture == null) {
                return [];
            }
            if (capture.orientation == null) {
                throw new Error("Invalid truesize capture '".concat(capture.objectId, "' for field '").concat(this.id, "' (missing orientation)"));
            }
            if (capture.calibrationid == null) {
                throw new Error("Invalid truesize capture '".concat(capture.objectId, "' for field '").concat(this.id, "' (missing calibrationId)"));
            }
            captures.push(capture);
        }
        return captures;
    };
    CollectionModelFieldAnchor.prototype.isCollectionLink = function () {
        return false;
    };
    CollectionModelFieldAnchor.prototype.getOwnedCaptureIds = function () {
        return this.getCaptureIds();
    };
    CollectionModelFieldAnchor.prototype.getCaptureIds = function () {
        if (!this.isPointToPoint()) {
            return [];
        }
        return this.stateValue.captures;
    };
    CollectionModelFieldAnchor.prototype.hasValue = function () {
        if (this.value != null) {
            if (this.tool === CollectionModelFieldAnchor.COLLLECTION_TOOL_LOCATION) {
                return location_field_1.CollectionModelFieldLocation.isValidLocation(this.value);
            }
            if (this.value.distance === 0 && this.value.bearing === 0 && this.value.placement === null) {
                return false;
            }
            return true;
        }
        return false;
    };
    CollectionModelFieldAnchor.PROVIDER_MANUAL = 'manual';
    CollectionModelFieldAnchor.PROVIDER_P2P = 'pointtopoint';
    CollectionModelFieldAnchor.PROVIDER_GPS = 'gps';
    CollectionModelFieldAnchor.PROVIDER_EDITED = 'edited';
    CollectionModelFieldAnchor.COLLLECTION_TOOL_VECTOR = 'VECTOR';
    CollectionModelFieldAnchor.COLLLECTION_TOOL_LOCATION = 'LOCATION';
    CollectionModelFieldAnchor.DEFAULT_PLACEMENT = 'Other';
    CollectionModelFieldAnchor.TYPE = core_api_1.IkeFieldType.ANCHOR;
    return CollectionModelFieldAnchor;
}(collection_field_1.CollectionModelField));
exports.CollectionModelFieldAnchor = CollectionModelFieldAnchor;
//# sourceMappingURL=anchor.field.js.map